<div class="row">
  <div class="col-md-12">
    <span mat-dialog-close matSuffix style="float: right">
      <mat-icon>close</mat-icon>
    </span>
  </div>
  <div class="col-md-12 text-center" *ngIf="data.isUpload">
    <span class="MM30">Upload Document</span>
    <p class="MM18">File should be .pdf, .jpeg, .png</p>
  </div>
  <div class="col-md-12 text-center" *ngIf="!data.isUpload">
    <span class="MM30">Uploaded Documents</span>
  </div>
</div>
<mat-dialog-content>
  <!--Document List & Mandatory Documents-->
  <div class="row row-flex">
    <div class="col-md-12" *ngIf="data.isUpload">
      <span class="MM18"> Mandatory Documents </span>
      <p class="MMI14" style="color: #013cdb">
        Please upload all the mandatory documents in this section
      </p>
    </div>
    <ng-container>
      <ng-container *ngFor="let item of data.claimDocs">
        <ng-container *ngIf="item.documentType !== 'Investigation Reports'">
          <div class="col-md-6 col-12" *ngIf="(item.documents && item.documents.length > 0) || item.mandatory">
            <!--Document Upload Functionality-->
            <div class="card m-2">
              <div class="row m-0" style="min-height: 10vh"> 
                <div class="col-9" style="align-items: center; display: flex; word-wrap: break-word" *ngIf="!data.isCashlessAnywhere">
                  <span class="MM18">{{ item.documentType}}
                    <ng-template [ngIf]="item.mandatory">*</ng-template>
                  </span>
                </div>
                <div class="col-9" style="align-items: center; display: flex; word-wrap: break-word" *ngIf="data.isCashlessAnywhere">
                  <span class="MM18">{{ item.documentType == 'TPA Email'? 'TPA Document':item.documentType}}
                    <ng-template [ngIf]="item.mandatory">*</ng-template>
                  </span>
                </div>

                <div class="col-3" *ngIf="data.isUpload && item.mandatory" style="align-items: center; display: flex"
                  id="upload_button">
                  <label class="save_btn, save_secondary" style="padding: 0.4rem">
                    <a color="primary">Upload</a>
                    <input multiple type="file" accept=".jpg, .jpeg, .pdf, .tiff"
                      (change)="addDocument($event, item)" />
                  </label>
                </div>
              </div>

              <!--Uploaded Documents List card-->
              <div class="row m-0 card">
                <div class="col-md-12" *ngIf="item.mandatory">
                  <div *ngFor="let doc of item.documents">
                    <span class="MM12" style="
                      word-wrap: break-word;
                      cursor: pointer;
                      color: #007bff;
                    " (click)="downloadReport(doc.file)">
                      <!-- {{ doc.name.substr(0,20) + "..." + doc.name.substr(-5) }} -->
                      {{doc.name}}
                    </span>
                    <ng-template [ngIf]="doc.canDelete">
                      <button class="btn btn-danger"
                        (click)="deleteDocument(item.documentType, doc.name)">Delete</button>
                    </ng-template>
                  </div>
                </div>
                <div class="col-md-12" *ngIf="!item.mandatory">
                  <div *ngFor="let doc of item.documents">
                    <span class="MM12" style=" 
                    word-wrap: break-word;
                    cursor: pointer;
                    color: #007bff;
                  " (click)="downloadReport(doc.url)" *ngIf="!data.isCashlessAnywhere">
                    {{doc.name}}
                    <!-- {{ doc.name.substr(0,10) + "..." + doc.name.substr(-5) }} -->
                  </span>
                    <span class="MM12" style="
                      word-wrap: break-word;
                      cursor: pointer;
                      color: #007bff;
                    " (click)="downloadReport(doc.url)" *ngIf="data.isCashlessAnywhere">
                    
                      {{doc.type == 'TPA Email'? modifiedName(doc.name):doc.name}}
                      <!-- {{ doc.name.substr(0,10) + "..." + doc.name.substr(-5) }} -->
                    </span>
                    <ng-template [ngIf]="doc.canDelete">
                      <button class="btn btn-danger"
                        (click)="deleteDocument(item.documentType, doc.name)">Delete</button>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    
  </div>

  <!--Other Documents-->
  <div class="row row-flex">
    <div class="col-md-12" *ngIf="data.isUpload">
      <span class="MM18"> Other Documents </span>
      <p class="MMI14" style="color: #013cdb">
        For all other documents, select the document category/ type & upload the
        files
      </p>
    </div>
    <div class="col-md-6" *ngIf="data.isUpload">
      <mat-label class="ml-2 MSB16"> Select Document Category </mat-label>
      <mat-form-field class="greenBorder" style="width: 100%" appearance="outline">
        <mat-select placeholder="Select Document Category" [(ngModel)]="selectedDocumentType" class="MM16" name="tpa">
          <ng-container *ngFor="let item of data.claimDocs">
            <mat-option *ngIf="!item.mandatory" [value]="item">
              {{ item.documentType }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-2" *ngIf="data.isUpload" style="align-items: center; display: flex" id="upload_button">
      <label class="save_btn, save_secondary" style="padding: 0.4rem;">
        <a color="primary">Choose File</a>
        <input [disabled]="!selectedDocumentType" multiple type="file" accept=".jpg, .jpeg, .pdf, .tiff"
          (change)="addDocument($event, selectedDocumentType)" />
      </label>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <div class="row row-flex">
    <div class="col-md-12">
      <button *ngIf="data.isUpload" mat-stroked-button color="primary" class="buttonSmallPrimaryBlue" (click)="close()">
        Submit
      </button>
    </div>
  </div>
</mat-dialog-actions>